export default __webpack_public_path__ + "7d1bf95.png";